import React, { Fragment, useEffect } from 'react';
// import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Drawer, Divider, Avatar, Typography } from '@material-ui/core';
// import { Hidden } from '@material-ui/core';

import useRouter from 'utils/useRouter';
import { Navigation } from 'components';
import navigationConfig, {
  accountant, hcns, tinh_cuoc, 
  manager,
  qh_manager,
  qh_accountant,
  hr,
  sale,
  userCustomer,
} from './navigationConfig';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    overflowY: 'auto'
  },
  content: {
    padding: theme.spacing(2)
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  },
  divider: {
    marginTop: theme.spacing(2)
  },
  navigation: {
    marginTop: theme.spacing(2)
  }
}));

const NavBar = props => {
  const { openMobile, onMobileClose, className, ...rest } = props;

  const classes = useStyles();
  const router = useRouter();
  const session = useSelector(state => state.session);

  const getConfig = () => {
    switch (session.user.role) {
      case 'accountant':
        if (session.user.navbar === 'qh_accountant') {
          return qh_accountant;
        }
        return accountant
      case 'tinh_cuoc':
        return tinh_cuoc;
      case 'hcns':
        return hcns;
      case 'admin':
        return navigationConfig;
      case 'manager':
        if (session.user.navbar === 'qh_manager') {
          return qh_manager;
        }
        return manager;
      case 'hr':
        return hr;
      case 'sale':
        return sale;
      case 'doi_tac':
        return userCustomer;
      default:
        return [];
    }
  };
  const configNAV = getConfig();

  useEffect(() => {
    if (openMobile) {
      onMobileClose && onMobileClose();
    }
    // eslint-disable-next-line
  }, [router.location.pathname]);

  const navbarContent = (
    <div className={classes.content}>
      <div className={classes.profile}>
        <Avatar
          alt="Person"
          className={classes.avatar}
          // component={RouterLink}
          src={session.user.avatar}
          // to="/profile/1/timeline"
        />
        <Typography className={classes.name} variant="h4">
          {session.user.fullname}
        </Typography>
        <Typography variant="body2">{session.user.role_name}</Typography>
      </div>
      <Divider className={classes.divider} />
      <nav className={classes.navigation}>
        {configNAV.map(list => (
          <Navigation
            component="div"
            key={list.title}
            pages={list.pages}
            title={list.title}
          />
        ))}
      </nav>
    </div>
  );

  return (
    <Fragment>
      {/* <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary">
          <div {...rest} className={clsx(classes.root, className)}>
            {navbarContent}
          </div>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Paper
          {...rest}
          className={clsx(classes.root, className)}
          elevation={1}
          square>
          {navbarContent}
        </Paper>
      </Hidden> */}
      <Drawer
        anchor="left"
        onClose={onMobileClose}
        open={openMobile}
        variant="temporary">
        <div {...rest} className={clsx(classes.root, className)}>
          {navbarContent}
        </div>
      </Drawer>
    </Fragment>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
